import http from "@/http-common";

export default class CodeHelpColService {
	
	getList(_params) {
		return http.get('/cm/codehelpcol', { params: _params}).then(res => res.data);
	}

	getColList(_params) {
		return http.get('/cm/codehelpcol/cols', { params: _params}).then(res => res.data);
	}

	getOne(_Id) {
		return http.get(`/cm/codehelpcol/${_Id}`).then(res => res.data);
	}

	insertOne(_data) {
		return http.post('/cm/codehelpcol',_data).then(res => res.data);
	}

	updateOne(_data) {
		return http.put('/cm/codehelpcol', _data).then(res => res.data);
	}

	pathOne(_compSeq, _majorSeq, _data) {
		return http.patch(`/cm/codehelpcol/${_compSeq}/${_majorSeq}`, _data).then(res => res.data);
	}

	deleteOne(_compSeq, _helpSeq, _colSerl)
	{
		return http.delete(`/cm/codehelpcol/${_compSeq}/${_helpSeq}/${_colSerl}`).then(res => res.data);
	}
	
}